/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Review3_QuoteInputs */

const es_landing_review3_quote = /** @type {(inputs: Landing_Review3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo pasamos en grande. Día estupendo y la experiencia fue perfecta. Sin duda repetiría.`)
};

const gl_landing_review3_quote = /** @type {(inputs: Landing_Review3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasámolo en grande. Día estupendo e a experiencia foi perfecta. Sen dúbida repetiría.`)
};

const en_landing_review3_quote = /** @type {(inputs: Landing_Review3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We had a blast. Wonderful day and a perfect experience. Would definitely do it again.`)
};

/**
* | output |
* | --- |
* | "We had a blast. Wonderful day and a perfect experience. Would definitely do it again." |
*
* @param {Landing_Review3_QuoteInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_review3_quote = /** @type {((inputs?: Landing_Review3_QuoteInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Review3_QuoteInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_review3_quote(inputs)
	if (locale === "en") return en_landing_review3_quote(inputs)
	return es_landing_review3_quote(inputs)
});